<div class="notification-content">
    <span>{{ data.message + ' - '}}</span>
    <a (click)="onView()">View</a> |
    <a (click)="onIgnore()">Ignore</a>
</div>
